import { useState, useMemo } from 'react';
import './ToolStyles.css';

const WordCounter = () => {
    const [text, setText] = useState('');

    const stats = useMemo(() => {
        if (!text) return null;
        // 中文字符数（Unicode 范围）
        const chineseChars = (text.match(/[一-鿿㐀-䶿]/g) || []).length;
        // 英文单词数
        const englishWords = (text.match(/[a-zA-Z]+/g) || []).length;
        // 总字符数（不含空白）
        const charsNoSpace = text.replace(/\s/g, '').length;
        // 总字符数（含空白）
        const charsWithSpace = text.length;
        // 行数
        const lines = text.split(/\n/).length;
        // 段落数
        const paragraphs = text.split(/\n\n+/).filter(Boolean).length || (text.trim() ? 1 : 0);

        return { chineseChars, englishWords, charsNoSpace, charsWithSpace, lines, paragraphs };
    }, [text]);

    return (
        <div className="tool-container">
            <div className="input-group">
                <label className="input-label">输入文本</label>
                <textarea
                    className="tool-textarea"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    rows={8}
                    placeholder="输入或粘贴文本..."
                />
            </div>
            {stats && (
                <div className="timestamp-grid">
                    <div className="timestamp-item">
                        <span className="timestamp-label">中文字符</span>
                        <span className="timestamp-value">{stats.chineseChars}</span>
                    </div>
                    <div className="timestamp-item">
                        <span className="timestamp-label">英文单词</span>
                        <span className="timestamp-value">{stats.englishWords}</span>
                    </div>
                    <div className="timestamp-item">
                        <span className="timestamp-label">总字符（含空格）</span>
                        <span className="timestamp-value">{stats.charsWithSpace}</span>
                    </div>
                    <div className="timestamp-item">
                        <span className="timestamp-label">总字符（不含空格）</span>
                        <span className="timestamp-value">{stats.charsNoSpace}</span>
                    </div>
                    <div className="timestamp-item">
                        <span className="timestamp-label">行数</span>
                        <span className="timestamp-value">{stats.lines}</span>
                    </div>
                    <div className="timestamp-item">
                        <span className="timestamp-label">段落数</span>
                        <span className="timestamp-value">{stats.paragraphs}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WordCounter;
